import { IAdBannerState } from '../../types/adBanner';
import { TReduxActions } from '../../types/redux';
import { SET_HAS_MORTGAGE_DISCLAIMER } from '../../actions/adBanner';

const defaultState: IAdBannerState = {
  hasMortgageDisclaimer: false,
};

export const adBannerReducer = (state: IAdBannerState = defaultState, action: TReduxActions): IAdBannerState => {
  switch (action.type) {
    case SET_HAS_MORTGAGE_DISCLAIMER:
      return {
        ...state,
        hasMortgageDisclaimer: action.payload,
      };
    default:
      return state;
  }
};

export { defaultState as adBannerDefaultState };
